import API from "@/package/config/axios";
import { AxiosResponse } from "axios";
import { IPermissionsResponse } from "@/types";

export const apiGetPermissions = (): Promise<
  AxiosResponse<IPermissionsResponse>
> => {
  return API.get("admin/permission");
};
